<template lang="pug">
  e-form-group(
  label="Период"
  inputType="calendar-range"
  :model="fields"
  :tabView="tabView"
  :formGroupStyle="formGroupStyle"
  :required="required"
  name="start"
  toName="end"
  :valueFormat="CALENDAR.valueFormat"
  :format="CALENDAR.format"
  type="date"
  )
</template>
<script>
  import {CALENDAR} from "../../../../config/config"
  import reportFieldMixin from '../../mixins/report-field-mixin'

  export default {
    mixins: [reportFieldMixin],
    name: 'period',
    computed: {
      CALENDAR () {
        return CALENDAR
      }
    }
  }
</script>
